import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Card, Row, NavItem, Nav, TabContent, TabPane, NavLink } from "reactstrap";
import classnames from "classnames";
// import { NavLink } from 'react-router-dom';
import { Colxx } from "../../../../components/common/CustomBootstrap";
import DataTablePagination from "../../../../components/DatatablePagination";
import { API_MEETING_ROOMS, gAPI_Internal_Property_By_Id } from "../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../helpers/AxiosAPI";
import ReactTable from 'react-table';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import "antd/dist/reset.css";
import CreateFrom from './components/form';
import AddOnForm from "./Addons/AddOnForm";
import AddOnList from "./Addons/AddOnList";
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
function MeetingRooms({ propertyId, locale }) {
    const [lst, setLst] = useState([]);
    const [showModel, setShowModel] = useState(false);
    const [id, setId] = useState('');
    const [isActiveTab, setIsActiveTab] = useState("space");
    const [showAddonModel, setShowAddonModel] = useState(false);
    const [propertyData, setPropertyData] = useState(null);
    const currencyFormat = (currency, value) =>
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);
    const handleCurrency = (currency) => {
        try {
            if (currency === "AUD") {
                currency = currencyFormat("AUD", 0)
                    .replace(/[A-Za-z]/g, "")
                    .charAt(currencyFormat("AUD", 0).indexOf("$") - 1);
                return currency;
            } else if (currency === "NZD") {
                currency = currencyFormat("NZD", 0)
                    .replace(/[A-Za-z]/g, "")
                    .charAt(currencyFormat("NZD", 0).indexOf("$") - 2);
                return currency;
            } else if (currency === "PHP") {
                currency = currencyFormat(currency, 0)
                    .replace(/[A-Za-z]/g, "")
                    .substring(0, 1);
                return currency;
            } else if (currency === "EUR") {
                currency = currencyFormat(currency, 0)
                    .replace(/[A-Za-z]/g, "")
                    .substring(0, 1);
                return currency;
            } else if (currency === "MYR") return "RM";
            else if (currency === "ISK") return "kr";
            else if (currency === "MYR") return "RM";
            else if (currency === "ISK") return "kr";
            else if (currency === "AED") {
                return "فلس";
            } else {
                currency = currencyFormat(currency, 0)
                    .replace(/[A-Za-z]/g, "")
                    .substring(0, 1);
                return currency;
            }
        } catch {
            currency = currencyFormat("NZD", 0)
                .replace(/[A-Za-z]/g, "")
                .charAt(currencyFormat("NZD", 0).indexOf("$") - 2);
            return currency;
        }
    };
    const dataTableColumns = [
        {
            Header: '',
            accessor: 'images',
            Cell: props => <p style={{ marginLeft: "12%" }} >{console.log(props.value)} <img
                alt="Thumbnail"
                src={
                    props.value.length > 0
                        ? props.value[0].url
                        : 'https://via.placeholder.com/250x150'
                }
                className="ml-2 my-3 list-thumbnail responsive border-0"
            /> </p >,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Name',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },

        {
            Header: 'Minimum Pax',
            accessor: 'minimumPax',
            Cell: props => <p style={{ marginLeft: "12%" }} > {props.value} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Maximum Pax',
            accessor: 'maximumPax',
            Cell: props => <p style={{ marginLeft: "12%" }} > {props.value} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Availability',
            accessor: 'availabilityCount',
            Cell: props => <p style={{ marginLeft: "12%" }} > {props.value} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Buffer Time',
            accessor: 'bufferTime',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value} mins </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "12%", color: `${props.value === "Active" ? "green" : "red"}` }} >{props.value} </p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Price',
            accessor: 'priceStart',
            Cell: props => <p
                style={{ marginLeft: "19%" }} >{handleCurrency(propertyData !== null ? propertyData.currency : "") + props.value} - {
                    handleCurrency(propertyData !== null ? propertyData.currency : "") + props.row._original.priceEnd}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: '',
            accessor: 'id',
            Cell: props => <p style={{ marginLeft: "10%" }} >
                <Button color="primary" size="xs" onClick={() => {
                    setId(props.value);
                    setShowModel(!showModel);
                }}>Edit</Button> </p>,
            style: { 'whiteSpace': 'unset' }
        },
    ];
    useEffect(() => {
        Load();
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setPropertyData(res.data);
            })
    }, [propertyId]);

    const Load = () => {
        setId('');
        AxiosAPI({
            method: 'get',
            url: `${API_MEETING_ROOMS}/all/${propertyId}`,
        }).then((result) => {
            console.log(result.data);
            setLst(result.data);
        });
    };

    // const changeOrderBy = (column) => {
    //     setOrderBy(orderOptions.find((x) => x.column === column));
    // };

    // const onSearchKey = (e) => {
    //     if (e.key === 'Enter') {
    //         setSearch(e.target.value.toLowerCase());
    //     }
    // };
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (fromIndex, toIndex, type, index) => {
        if (toIndex < 0) return;
        if (type === "LIST-ITEM") {
            const categories = reorder(lst, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({
                    id: item.id,
                    displayOrder: i
                })
            });
            AxiosAPI({
                method: 'post',
                url: `${API_MEETING_ROOMS}/display-order`,
                data: { data: data },
            }).then((res) => {
                return setLst(categories);
            }).catch((err) => {
                console.log('err', err);
            });
        } else return new Error("NOT A VALID LIST");
    };
    return (
        <Fragment>
            <Row>
                <Colxx md={12}>
                    <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
                        <style>{style_css}</style>
                        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
                            <NavLink
                                style={{ background: 'none', cursor: 'pointer' }}
                                className={classnames({
                                    active: isActiveTab === "space",
                                    "nav-link": true
                                })}
                                onClick={() => setIsActiveTab("space")}
                                to="#"
                            >
                                <span style={{ color: `${isActiveTab === "space" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}>
                                    Space
                                </span>
                            </NavLink>
                        </NavItem>
                        <NavItem className="text-center" style={{ width: 'auto', background: '' }}>
                            <NavLink
                                style={{ background: 'none', cursor: 'pointer' }}
                                className={classnames({
                                    active: isActiveTab === "addOns",
                                    "nav-link": true
                                })}
                                onClick={() => setIsActiveTab("addOns")}
                                to="#"
                            >
                                <span style={{ color: `${isActiveTab === "addOns" ? 'var(--theme-color-1)' : '#8f8f8f'}` }}>
                                    Space Add-On's
                                </span>
                            </NavLink>
                        </NavItem>

                    </Nav>
                </Colxx>
            </Row>
            <TabContent activeTab={isActiveTab} className="">
                <TabPane tabId="space" className="chat-app-tab-pane">
                    <div className="row mt-2 mb-2">
                        <div className='col-md-12 '>
                            <Button
                                color="primary"
                                outline
                                size="xs"
                                onClick={() => {
                                    setId('');
                                    setShowModel(!showModel);
                                }}
                            // style={{ width: '100%', borderRadius: '6px' }}
                            >
                                + Add Space
                            </Button>
                        </div>
                    </div>
                    <CreateFrom Load={Load} toggle={() => setShowModel(!showModel)}
                        formLabel={id === '' ? 'Create Space' : 'Update Space'}
                        visible={showModel} id={id === '' ? undefined : id}
                        currency={propertyData !== null ? propertyData.currency : ""}></CreateFrom>
                    {lst.length > 0 ?
                        <ReactDragListView
                            nodeSelector=".ant-list.draggable"
                            lineClassName="dragLine"
                            onDragEnd={(fromIndex, toIndex) =>
                                onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                            }
                        >
                            {lst.map((item, index) => (
                                <List key={index} className="draggable">
                                    <div className="d-flex flex-row mb-3">
                                        <span className="mt-3 draggable"><a href="#"><i className="simple-icon-menu"></i></a></span>
                                        <Colxx xxs="12" key={index}>
                                            <Card className="d-flex flex-row mb-3">
                                                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                                    <div className="card-body mt-0 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                                        <img
                                                            alt="Thumbnail"
                                                            src={
                                                                item.images.length > 0
                                                                    ? item.images[0].url
                                                                    : 'https://via.placeholder.com/250x150'
                                                            }
                                                            className="list-thumbnail responsive border-0"
                                                        />
                                                        <p className="mb-1 text-small w-15 w-sm-100 ml-2">
                                                            <b>{item.name}</b>
                                                        </p>
                                                        <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                            (Minimum Pax)<br />
                                                            <div className="ml-4">
                                                                {item.minimumPax}
                                                            </div>
                                                        </p>
                                                        <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                            (Maximum Pax)<br />
                                                            <div className="ml-4">
                                                                {item.maximumPax}
                                                            </div>
                                                        </p>
                                                        <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                            (Availability)<br />
                                                            <div className="ml-4">
                                                                {item.availabilityCount}
                                                            </div>
                                                        </p>
                                                        <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                            (Buffer Time)<br />
                                                            <div className="ml-4">
                                                                {item.bufferTime}
                                                            </div>
                                                        </p>
                                                        <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                            (Price)<br />
                                                            <div>
                                                                {handleCurrency(propertyData !== null ? propertyData.currency : "") +
                                                                    item.priceStart} -
                                                                {handleCurrency(propertyData !== null ? propertyData.currency : "") +
                                                                    item.priceEnd}
                                                            </div>
                                                        </p>
                                                        <p className="mb-1 text-small w-15 w-sm-100"
                                                            style={{ color: `${item.status === "Active" ? "green" : "red"}` }}>
                                                            {item.status}
                                                        </p>
                                                        <div className="w-10 w-sm-100">
                                                            <Button color="primary" size="xs" onClick={() => {
                                                                setId(item.id);
                                                                setShowModel(!showModel);
                                                            }}>Edit</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Colxx>
                                    </div>
                                </List>
                            ))}
                        </ReactDragListView> : null}

                    {/* <Row className="col-md-12 mt-4">
                        <Colxx xxs="12">
                            <Card className="d-flex flex-row mb-3">
                                <Fragment>
                                    <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                        {lst.length > 0 ? (
                                            <ReactTable
                                                data={lst}
                                                columns={dataTableColumns}
                                                defaultPageSize={5}
                                                filterable={false}
                                                showPageJump={true}
                                                PaginationComponent={DataTablePagination}
                                                showPageSizeOptions={true}
                                                className="-striped -highlight -bordered"
                                                style={{ width: "100%" }}
                                            />
                                        ) : ""
                                        }
                                    </div>
                                </Fragment>
                            </Card>
                        </Colxx>
                    </Row> */}
                </TabPane>
            </TabContent>
            <TabContent activeTab={isActiveTab} className="">
                <TabPane tabId="addOns" className="chat-app-tab-pane">
                    <Row className="mt-2 mb-2">
                        <Colxx md={12}>
                            <Button
                                color="primary"
                                outline
                                size="xs"
                                onClick={() => {
                                    setId('');
                                    setShowAddonModel(!showAddonModel);
                                }}
                            // style={{ width: '100%', borderRadius: '6px' }}
                            >
                                + Add Add-On's
                            </Button>
                        </Colxx>
                    </Row>
                    <AddOnForm
                        visible={showAddonModel}
                        toggle={() => setShowAddonModel(!showAddonModel)}
                        formLabel="Create Add-On's"></AddOnForm>
                    <AddOnList></AddOnList>
                </TabPane>
            </TabContent>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default (connect(mapStateToProps, {})(MeetingRooms));
